import React, { useEffect } from "react";
import IcecastMetadataPlayer, { IcyMetadata } from "icecast-metadata-player";
import WidgetRadioPlayer from "./widgetRadioPlayer/WidgetRadioPlayer";
import FullScreenRadioPlayer from "./fullScreenRadioPlayer/FullScreenRadioPlayer";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux-hooks";
import {
  selectMainState,
  setMetadataState,
  setPlayerState,
} from "../../../../store/slices/main";
import { getDefaultCovers } from "../../../../api/asyncThuncks/settings";

const RadioPlayer = () => {
  const dispatch = useAppDispatch();
  const {
    radioPlayer: { metadata, overTop, viewPlayer, player },
    defaultCover,
  } = useAppSelector(selectMainState);

  const artist = metadata?.split("-")[0];
  const trackName = metadata?.split("-")[1];
  const screenWidth = window.screen.width < 799;

  useEffect(() => {
    dispatch(
      setPlayerState(
        new IcecastMetadataPlayer("https://stream.radio.silpo.ua/silpo", {
          onMetadata: (metadata: IcyMetadata) => {
            if (metadata.StreamTitle) {
              dispatch(setMetadataState(metadata.StreamTitle));
            }
          },
          metadataTypes: ["icy"],
        })
      )
    );
  }, []);

  useEffect(() => {
    dispatch(getDefaultCovers());
  }, [dispatch]);

  return (
    <div className="w-full">
      {player && viewPlayer && overTop && screenWidth ? (
        <FullScreenRadioPlayer
          cover={defaultCover}
          metadata={metadata}
          trackName={trackName}
          artist={artist}
          player={player}
        />
      ) : (
        player && (
          <WidgetRadioPlayer
            cover={defaultCover}
            metadata={metadata}
            trackName={trackName}
            artist={artist}
            player={player}
          />
        )
      )}
    </div>
  );
};

export default RadioPlayer;
